export default () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="838.585px"
    height="541.122px"
    viewBox="2.234 299.282 838.585 541.122"
    enableBackground="new 2.234 299.282 838.585 541.122"
    xmlSpace="preserve"
  >
    <path
      d="M549.933,308.746c-3.158-5.067-13-9.464-18.959-9.464H362.798c-5.976,0-6.183,4.495-3.227,9.665l297.317,516.302
	c2.953,5.188,9.979,5.516,15.662,3.765l162.186-51.265c5.699-1.75,7.762-8.502,4.602-13.566L549.933,308.746z"
    />
    <path
      d="M146.811,825.353l143.481-306.24v296.29c0,26.507,28.097,24.986,34.073,24.986h279.58c5.975,0,8.396-9.599,5.443-14.794
	l-288.872-512.01c-2.954-5.179-7.728-5.179-10.681,0l-72.333,127.012c-2.956,5.178-9.566,11.729-14.778,14.623
	C149.549,495.818,50.882,550.033,7.158,569.225c-6.56,2.877-6.199,11.136-1.083,16.142c9.723,9.506,30.381,31.266,49.461,57.444
	c11.111,15.241,20.831,32.234,28.773,49.1c2.55,5.399,2.07,14.021-0.884,19.207L21.292,825.595
	c-2.919,5.194-0.472,14.794,5.488,14.794h104.354C137.09,840.389,144.115,830.677,146.811,825.353 M63.383,589.421
	c-2.677-2.379-2.37-5.53,0.799-7.188c30.785-16.126,176.429-92.563,216.939-117.327c3.041-1.871,4.158-0.876,2.534,2.319
	L145.609,738.509c-1.632,3.179-3.487,2.922-4.275-0.565C136.146,714.999,115.065,635.136,63.383,589.421"
    />
  </svg>
);
